/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankResource } from './bankResource';
import { ClientResource } from './clientResource';
import { SpecialistResource } from './specialistResource';


export interface BrokerageTipResource { 
    id: number;
    currency: BrokerageTipResource.CurrencyEnum;
    name: string;
    image: string;
    client: ClientResource;
    bank: BankResource;
    specialist: SpecialistResource;
    isProgress: boolean;
    brokerageValue: number;
}
export namespace BrokerageTipResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


